module.exports = __webpack_public_path__ + "img/wannas-the-tayac.c7c02105.png";